<template>
  <div :style="wrapStyle" class="pagination-wrap">
    <a-pagination
      :hideOnSinglePage="hideOnSinglePage"
      show-quick-jumper
      show-size-changer
      :page-size-options="pageSizeOptions"
      :current="current"
      :total="total"
      :size="size"
      :show-total="total => `共 ${total} 条`"
      @showSizeChange="onShowSizeChange"
      @change="handleCurrentChange"
    />
  </div>
</template>

<script>
export default {
  props: {
    current: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    total: {
      type: Number,
      default: 0
    },
    wrapStyle: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: ''
    },
    hideOnSinglePage: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      pageSizeOptions: ['10', '20', '50']
    }
  },
  methods: {
    onShowSizeChange(val, pageSize) {
      this.$emit('size', pageSize)
    },
    handleCurrentChange(val) {
      this.$emit('current', val)
    }
  }
}
</script>

<style scoped lang="less">
.pagination-wrap {
  text-align: right;
  padding: 24px 0;
}
</style>
